import React, { Component } from 'react'
import { Route, Switch } from 'react-router-dom'
import i18n from '../../i18n'
import { I18nextProvider } from 'react-i18next'
import AppWrapper from '../../components/appWrapper/appWrapperComponent'
import routes from './routes'
import VerifyEmail from '../verifyEmail/verifyEmailRoute'
import PropTypes from 'prop-types'

// Scroll to top on all route changes per
// https://github.com/ReactTraining/react-router/issues/3950#issuecomment-281181809
class ScrollToTop extends Component {
  componentDidUpdate (prevProps) {
    if (this.props.location !== prevProps.location) {
      window.scrollTo(0, 0)
    }
  }

  render () {
    return null
  }
}
ScrollToTop.propTypes = {
  location: PropTypes.any
}
const ScrollToTopOnNav = () => <Route component={ScrollToTop} />

export default class Root extends Component {
  constructor () {
    super()
    this.views = {}
  }

  loadView (fileName) {
    if (this.views[fileName]) {
      return this.views[fileName]
    }

    new Promise(resolve => {
      switch (fileName) {
        case routes.home:
          require.ensure(['../home/homeRoute.js'], require => {
            this.forceUpdate()
            resolve(require('../home/homeRoute').default)
          })
          break
        case routes.aboutBasics:
          require.ensure(['../aboutBasics/aboutBasicsRoute'], require => {
            this.forceUpdate()
            resolve(require('../aboutBasics/aboutBasicsRoute').default)
          })
          break

        case routes.theBasics:
          require.ensure(['../theBasics/theBasicsRoute'], require => {
            this.forceUpdate()
            resolve(require('../theBasics/theBasicsRoute').default)
          })
          break
        case routes.aboutFaq:
          require.ensure(['../aboutFaq/aboutFaqRoute'], require => {
            this.forceUpdate()
            resolve(require('../aboutFaq/aboutFaqRoute').default)
          })
          break
        case routes.roadmapToCollege:
          require.ensure(
            ['../roadmapToCollege/roadmapToCollegeRoute'],
            require => {
              resolve(
                require('../roadmapToCollege/roadmapToCollegeRoute').default
              )
              this.forceUpdate()
            }
          )
          break
        case routes.endorsements:
          require.ensure(['../endorsements/endorsementsRoute'], require => {
            this.forceUpdate()
            resolve(require('../endorsements/endorsementsRoute').default)
          })
          break
        case routes.artsHumanities:
          require.ensure(['../artsHumanities/artsHumanitiesRoute'], require => {
            this.forceUpdate()
            resolve(require('../artsHumanities/artsHumanitiesRoute').default)
          })
          break
        case routes.multidisciplinary:
          require.ensure(
            ['../multidisciplinary/multidisciplinaryRoute'],
            require => {
              resolve(
                require('../multidisciplinary/multidisciplinaryRoute').default
              )
            }
          )
          break
        case routes.publicService:
          require.ensure(['../publicService/publicServiceRoute'], require => {
            resolve(require('../publicService/publicServiceRoute').default)
          })
          break
        case routes.businessIndustry:
          require.ensure(
            ['../businessIndustry/businessIndustryRoute'],
            require => {
              resolve(
                require('../businessIndustry/businessIndustryRoute').default
              )
            }
          )
          break
        case routes.stem:
          require.ensure(['../stem/stemRoute'], require => {
            resolve(require('../stem/stemRoute').default)
          })
          break
        case routes.takeTheQuiz:
          require.ensure(['../takeTheQuiz/takeTheQuizRoute'], require => {
            resolve(require('../takeTheQuiz/takeTheQuizRoute').default)
          })
          break
        case routes.findYourPath:
          require.ensure(['../findYourPath/findYourPathRoute'], require => {
            resolve(require('../findYourPath/findYourPathRoute').default)
          })
          break
        case routes.artsHumanitiesCareers:
          require.ensure(
            ['../artsHumanitiesCareers/artsHumanitiesCareersRoute'],
            require => {
              resolve(
                require('../artsHumanitiesCareers/artsHumanitiesCareersRoute')
                  .default
              )
            }
          )
          break
        case routes.multidisciplinaryCareers:
          require.ensure(
            ['../multidisciplinaryCareers/multidisciplinaryCareersRoute'],
            require => {
              resolve(
                require('../multidisciplinaryCareers/multidisciplinaryCareersRoute')
                  .default
              )
            }
          )
          break
        case routes.publicServiceCareers:
          require.ensure(
            ['../publicServiceCareers/publicServiceCareersRoute'],
            require => {
              resolve(
                require('../publicServiceCareers/publicServiceCareersRoute')
                  .default
              )
            }
          )
          break
        case routes.businessIndustryCareers:
          require.ensure(
            ['../businessIndustryCareers/businessIndustryCareersRoute'],
            require => {
              resolve(
                require('../businessIndustryCareers/businessIndustryCareersRoute')
                  .default
              )
            }
          )
          break
        case routes.stemCareers:
          require.ensure(['../stemCareers/stemCareersRoute'], require => {
            resolve(require('../stemCareers/stemCareersRoute').default)
          })
          break
        case routes.gradPlanner:
          require.ensure(['../gradPlanner/gradPlannerRoute'], require => {
            resolve(require('../gradPlanner/gradPlannerRoute').default)
          })
          break
        default:
          break
      }
    })
      .then(View => {
        this.views[fileName] = <View />
      })
      .then(() => this.forceUpdate())
      .catch(err => {
        console.error(err)
        throw new Error(err)
      })

    return <div />
  }
  render () {
    return (
      <I18nextProvider i18n={i18n}>
        <AppWrapper>
          <ScrollToTopOnNav />
          <Switch>
            <Route
              path={routes.home}
              exact
              component={() => this.loadView(routes.home)}
            />
            <Route
              path={routes.aboutBasics}
              exact
              component={() => this.loadView(routes.aboutBasics)}
            />
            <Route
              path={routes.aboutFaq}
              exact
              component={() => this.loadView(routes.aboutFaq)}
            />
            <Route
              path={routes.roadmapToCollege}
              exact
              component={() => this.loadView(routes.roadmapToCollege)}
            />
            <Route
              path={routes.endorsements}
              exact
              component={() => this.loadView(routes.endorsements)}
            />
            <Route
              path={routes.artsHumanities}
              exact
              component={() => this.loadView(routes.artsHumanities)}
            />
            <Route
              path={routes.publicService}
              exact
              component={() => this.loadView(routes.publicService)}
            />
            <Route
              path={routes.businessIndustry}
              exact
              component={() => this.loadView(routes.businessIndustry)}
            />
            <Route
              path={routes.multidisciplinary}
              exact
              component={() => this.loadView(routes.multidisciplinary)}
            />
            <Route
              path={routes.stem}
              exact
              component={() => this.loadView(routes.stem)}
            />
            <Route
              path={routes.artsHumanitiesCareers}
              exact
              component={() => this.loadView(routes.artsHumanitiesCareers)}
            />
            <Route
              path={routes.publicServiceCareers}
              exact
              component={() => this.loadView(routes.publicServiceCareers)}
            />
            <Route
              path={routes.businessIndustryCareers}
              exact
              component={() => this.loadView(routes.businessIndustryCareers)}
            />
            <Route
              path={routes.multidisciplinaryCareers}
              exact
              component={() => this.loadView(routes.multidisciplinaryCareers)}
            />
            <Route
              path={routes.stemCareers}
              exact
              component={() => this.loadView(routes.stemCareers)}
            />
            <Route
              path={routes.gradPlanner}
              exact
              component={() => this.loadView(routes.gradPlanner)}
            />
            <Route
              path={routes.findYourPath}
              exact
              component={() => this.loadView(routes.findYourPath)}
            />
            <Route
              path={routes.theBasics}
              exact
              component={() => this.loadView(routes.theBasics)}
            />
            <Route
              path={routes.takeTheQuiz}
              exact
              component={() => this.loadView(routes.takeTheQuiz)}
            />
            {/* This is not split because we want it to load very very quickly */}
            <Route path={routes.emailValidated} exact component={VerifyEmail} />
          </Switch>
        </AppWrapper>
      </I18nextProvider>
    )
  }
}
Root.propTypes = {}



// WEBPACK FOOTER //
// ./src/routes/root/rootRoute.js